type EventItem = {
  id: number;
  start_time: number; // Unix timestamp (milliseconds)
  end_time: number; // Unix timestamp (milliseconds)
  title: string;
  description?: string; // Optional field
  location?: string; // Optional field
  category?: string; // Op
  group?: string;
};

export function groupEventsByDayAndGroup(
  events: EventItem[],
): Record<string, Record<string, EventItem[]>> {
  return events.reduce<Record<string, Record<string, EventItem[]>>>(
    (acc, event) => {
      // Create a new Date object for the start_time
      const date = new Date(event.start_time);

      // Convert to ISO string (YYYY-MM-DD) for grouping by day
      const day = date.toISOString().split('T')[0];

      // If the day does not exist, create an empty object
      if (!acc[day]) {
        acc[day] = {};
      }

      // Group by 'group' within the same day
      const group = event.group || 'no-group'; // Default to "no-group" if no group is provided

      // If the group does not exist, create an empty array
      if (!acc[day][group]) {
        acc[day][group] = [];
      }

      // Push the event to the corresponding day and group
      acc[day][group].push(event);

      return acc;
    },
    {},
  );
}

export function groupEventsByWeekAndGroup(
  events: EventItem[],
): Record<string, Record<string, EventItem[]>> {
  return events.reduce<Record<string, Record<string, EventItem[]>>>(
    (acc, event) => {
      // Create a new Date object for the start_time
      const date = new Date(event.start_time);

      // Get the first day of the week (Sunday)
      const startOfWeek = new Date(date);
      startOfWeek.setDate(date.getDate() - date.getDay()); // Adjust to the start of the week (Sunday)
      startOfWeek.setHours(0, 0, 0, 0); // Reset time to 00:00:00

      // Convert to ISO string (YYYY-MM-DD) for grouping
      const weekStartDate = startOfWeek.toISOString().split('T')[0];

      // If the week does not exist, create an empty object
      if (!acc[weekStartDate]) {
        acc[weekStartDate] = {};
      }

      // Group by 'group' within the same week
      const group = event.group || 'no-group'; // Default to "no-group" if no group is provided

      // If the group does not exist, create an empty array
      if (!acc[weekStartDate][group]) {
        acc[weekStartDate][group] = [];
      }

      // Push the event to the corresponding week and group
      acc[weekStartDate][group].push(event);

      return acc;
    },
    {},
  );
}
export function groupEventsByMonthAndGroup(
  events: EventItem[],
): Record<string, Record<string, EventItem[]>> {
  return events.reduce<Record<string, Record<string, EventItem[]>>>(
    (acc, event) => {
      // Create a new Date object for the start_time
      const date = new Date(event.start_time);

      // Set the date to the first day of the month
      const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);

      // Convert to ISO string (YYYY-MM-DD) for grouping
      const monthStartDate = startOfMonth.toISOString().split('T')[0];

      // If the month does not exist, create an empty array
      if (!acc[monthStartDate]) {
        acc[monthStartDate] = {};
      }

      // Group by 'group' within the same week
      const group = event.group || 'no-group'; // Default to "no-group" if no group is provided

      // If the group does not exist, create an empty array
      if (!acc[monthStartDate][group]) {
        acc[monthStartDate][group] = [];
      }

      // Push the event to the corresponding week and group
      acc[monthStartDate][group].push(event);

      return acc;
    },
    {},
  );
}
